import React from 'react';
import { useApp } from '../../context/AppContext';

export function AlgemeneVoorwaardeToggle() {
  const { state, dispatch } = useApp();

  const handleToggle = () => {
    dispatch({ type: 'TOGGLE_INCLUDE_ALGEMENE_VOORWAARDE' });
  };

  if (!state.algemeneVoorwaarde) {
    return null;
  }

  return (
    <div className="w-full">
      <div className="bg-white dark:bg-black border border-gray-200 dark:border-blue-600 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <svg className="w-5 h-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
            </svg>
            <div>
              <h3 className="text-sm font-medium text-gray-900 dark:text-white">
                Algemene Voorwaarde
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-300">
                {state.algemeneVoorwaarde.name}
              </p>
            </div>
          </div>

          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={state.includeAlgemeneVoorwaarde}
              onChange={handleToggle}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
            <span className="ml-3 text-sm font-medium text-gray-900 dark:text-white">
              {state.includeAlgemeneVoorwaarde ? 'Aan' : 'Uit'}
            </span>
          </label>
        </div>

        {state.includeAlgemeneVoorwaarde && (
          <div className="mt-2 text-xs text-green-600 dark:text-green-400">
            ✓ De algemene voorwaarde wordt toegevoegd aan de PDF
          </div>
        )}
      </div>
    </div>
  );
}